import styled from 'styled-components'

export const SkillsDescription = styled.h3 `
color: #fff;
font-size: 22px;
font-weight: bold;
`
export const SkillsIcon = styled.img `
	width: 96px;
	height: 96px;
	transform: ${(props) => props.var === 'css' ? 'scale(1.1)' : ''}
`